import { render, staticRenderFns } from "./URLIntegration.vue?vue&type=template&id=0472c597&"
import script from "./URLIntegration.vue?vue&type=script&lang=ts&"
export * from "./URLIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports